<app-slide id="safeguardingSlide" title="Additional Information"
    supportingText="The following questions will assist us to establish whether you require any support in your new home. We are not judging you by any answers that you give so please be as honest as possible. Your answers will not impact on our decision to offer you a home."
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'safeguarding'"
    [slideCompleted]="formState.progress.safeguardingComplete">
    <div class="alert alert-danger" *ngIf="showError">
        {{errorMessage}}
    </div>

    <div id="safeguarding-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it
            again.
        </p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title | titlecase}},
                    {{error.msg}}
                </a>
            </li>
        </ul>
    </div>

    <ng-container *ngIf="fields | async as fields">
        <div>
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            <div class="section ng-empty" *ngIf="showSubmit">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="form-group">
                            <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                                <span>Back</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="position: relative;"
                                (click)="onSubmit()" (disabled)="isDisabled">
                                <span>Save &amp; Continue Securely</span>
                                <app-spinner *ngIf="submitting" class="applicationSubmitSpinner"></app-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</app-slide>